import { render } from "./MainMenu.vue?vue&type=template&id=2f747c27&scoped=true"
import script from "./_MainMenu.js?vue&type=script&lang=js&external"
export * from "./_MainMenu.js?vue&type=script&lang=js&external"

import "./_MainMenu.less?vue&type=style&index=0&id=2f747c27&lang=less&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f747c27"]])

export default __exports__